
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly authenticate your customers' bank accounts for use with the Ansa API to enable wallet funding over ACH"
};
export const partnerProps = {
  partner: 'Ansa',
  clientLibrary: 'ansa',
  subtitle: metadata.description,
  registrationUrl: 'https://www.ansa.dev/',
  apiUrl: 'https://docs.ansa.dev',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Ansa have partnered to offer businesses a frictionless, secure way for customers to add funds to their closed
loop/stored value wallets via ACH. Use Plaid Link to instantly authenticate your customers' bank account and generate a
token that can be used to process ACH payments with Ansa. Accounts linked with Plaid can be used with
Ansa's Payment Method, Add Balance, and Auto Reload APIs. This guide is designed for those who already have developer
accounts with both Ansa and Plaid. If that's not you, sign up for a Plaid Dashboard account, and reach out to Ansa at
`}<a parentName="p" {...{
        "href": "mailto:hello@getansa.com"
      }}>{`hello@getansa.com`}</a>{` to get an Ansa account.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthSignalInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
